import { useEffect, useState } from "react";
import { api } from "@/lib/auth";

const KEY = "tt-partner-code";
export const PARTNER_PRICE = { gates: "$223", quantum: "$223", bundle: "$373" };
export const FULL_PRICE = { gates: "$297", quantum: "$297", bundle: "$497" };

// Keeps a partner invitation code from ?partner= so it survives sign-up and moving between offers.
export const partnerCode = () => {
  const fromUrl = new URLSearchParams(window.location.search).get("partner");
  if (fromUrl) localStorage.setItem(KEY, fromUrl.trim().toUpperCase().slice(0, 16));
  return localStorage.getItem(KEY) || "";
};

// The partner offer this visitor is holding: { code, valid, inviter, claimed } or null.
export const usePartnerOffer = () => {
  const [offer, setOffer] = useState(null);
  useEffect(() => {
    const code = partnerCode();
    if (!code) return undefined;
    let alive = true;
    api.get(`/partner-invite/${encodeURIComponent(code)}`).then(({ data }) => alive && setOffer({ code, ...data })).catch(() => {});
    return () => {
      alive = false;
    };
  }, []);
  return offer;
};

// True when checkout will charge this person the partner price.
export const hasPartnerPrice = (user, offer) => Boolean(user?.partner_discount || (offer?.valid && !offer?.claimed));

// Owners of one app pay $200 for the other (beats the partner price).
export const UPGRADE_PRICE = "$200";
export const isUpgrade = (user, product) => product !== "bundle" && Boolean(product === "gates" ? user?.quantum : user?.initiate);
